import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Clock from 'react-live-clock';
const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

const Footer = () => {
  const envVariables = useSelector((state) => state.environment);
  const [versionInfo, setVersionInfo] = useState(null);

  useEffect(() => {
    fetch('/version.json')
      .then((response) => response.json())
      .then((data) => setVersionInfo(data))
      .catch(() => {
        try {
          const version = require('../../version.json');
          setVersionInfo(version);
        } catch (error) {
          console.warn('Version info not available', error?.message);
        }
      });
  }, []);

  return (
    <footer className="footer">
      <span className="left">
        {envVariables?.environment || 'localhost'} | v{versionInfo?.version || 'dev'}
      </span>
      <span>
        <Clock format={'DD MMMM YYYY | dddd, HH:mm:ss'} ticking={true} /> ({timeZone})
      </span>
      <span className="right">
        <a href="mailto:f2w-support@tui.com?Subject=F2W Support" target="_top">
          Support
        </a>
        <span style={{ color: '#ddd' }}> | </span>
        <a href="https://confluence.tuigroup.com/display/ITDS/Fly2Work" target="_blank" rel="noreferrer">
          Wiki
        </a>
      </span>
    </footer>
  );
};

export default Footer;
